import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDHsRouletteResult implements ICommand
{

	public Number : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Number = ba.readUint8();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint8(this.Number);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDHsRouletteResult();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Number(B)='+this.Number+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 0;
	}

	public getCmdName() : string
	{
		return 'HsRouletteResult';
	}

}
